module.exports = __webpack_public_path__ + "img/Picture 8.48ccdc41.png";